import React from 'react';

import SEOHead from './SEOHead';

interface SEOOptimizerProps {
  title: string;
  description: string;
  keywords: string;
  ogImage?: string;
  ogImageAlt?: string;
  structuredData?: Record<string, any>;
  ogType?: string;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
  tags?: string[];
}

const SEOOptimizer: React.FC<SEOOptimizerProps> = ({
  title,
  description,
  keywords,
  ogImage,
  ogImageAlt,
  structuredData,
  ogType = 'article',
  author,
  publishedTime,
  modifiedTime,
  tags,
}) => {
  return (
    <SEOHead
      title={title}
      description={description}
      keywords={keywords}
      ogImage={ogImage}
      ogImageAlt={ogImageAlt}
      ogType={ogType}
      ogArticlePublishedTime={publishedTime}
      ogArticleModifiedTime={modifiedTime}
      ogArticleAuthor={author}
      ogArticleTags={tags}
      structuredData={structuredData}
      pageType="blog"
    />
  );
};

export default SEOOptimizer;
